import React, { Component } from 'react'
import PropTypes from 'prop-types'

class SrcConsent extends Component {
  state = {
    srcConsentAccepted: false,
    srcRememberMe: false,
  }

  componentDidMount() {
    const srcConsent = document.getElementById('srcConsent')
    srcConsent.addEventListener('checkoutAsGuest', this.handleCheckoutAsGuest)
    srcConsent.addEventListener('rememberMe', this.handleRememberMe)
  }

  componentWillUnmount() {
    const srcConsent = document.getElementById('srcConsent')
    srcConsent.removeEventListener(
      'checkoutAsGuest',
      this.handleCheckoutAsGuest,
    )
    srcConsent.removeEventListener('rememberMe', this.handleRememberMe)
  }

  handleCheckoutAsGuest = event => {
    const value = event.detail.checkoutAsGuest

    this.setState({ srcConsentAccepted: value })
    this.props.onConsentChange?.(value)
  }

  handleRememberMe = event => {
    const value = event.detail.rememberMe

    this.setState({ srcRememberMe: value })
    this.props.onRememberMeChange?.(value)

    if (!value) {
      localStorage.setItem('srcRememberMe', 'false')
    }
  }

  render() {
    const { displayRememberMe } = this.props

    return (
      <src-consent
        id="srcConsent"
        locale="pt_BR"
        src-dpa-id={process.env.REACT_APP_MASTERCARD_SRC_DPA_ID}
        display-remember-me={`${displayRememberMe}`}
      />
    )
  }
}

SrcConsent.propTypes = {
  displayRememberMe: PropTypes.bool,
  onConsentChange: PropTypes.func,
  onRememberMeChange: PropTypes.func,
}

SrcConsent.defaultProps = {
  displayRememberMe: true,
  onConsentChange: () => {},
  onRememberMeChange: () => {},
}

export default SrcConsent
